(
  /**
   * Runs this script
   *
   * @param window
   * @param document
   * @param undefined
   */
  function (window, document, undefined) {

    /**
     * Handler to run once the DOM Content Has loaded. It removes the no-js CSS class from the body tag if JS
     * enabled in the browser.
     */
    function waitForContentLoaded () {
      document.removeEventListener('DOMContentLoaded', waitForContentLoaded);

      document.body.classList.remove('no-js');
    }

    // Listen for the the DOM Content to be loaded
    document.addEventListener('DOMContentLoaded', waitForContentLoaded);
  }
)(window, document);
